'use strict';

exports.__esModule = true;
exports.queryStringFromObject = exports.WF_PEER_RECOMMENDATION_TABS_FOR_DROPDOWN = exports.WF_GROUP_REVIEWS_LAYOUTS = exports.WF_PEER_RECOMMENDATION_LAYOUTS = exports.WF_HORIZONTAL_LAYOUTS = exports.WF_GRID_LAYOUTS = exports.WF_CAROUSEL_LAYOUTS = exports.WF_MICRO_STAR_LAYOUTS = exports.WF_LIST_LAYOUTS = exports.SPECIALIST_TABS = exports.PRACTICE_TABS = exports.PROFILE_TYPES = exports.SPECIALIST_PROFILE_TYPE = exports.PRACTICE_PROFILE_TYPE = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRACTICE_PROFILE_TYPE = exports.PRACTICE_PROFILE_TYPE = 'practice';
var SPECIALIST_PROFILE_TYPE = exports.SPECIALIST_PROFILE_TYPE = 'specialist';
var PROFILE_TYPES = exports.PROFILE_TYPES = [{
  id: PRACTICE_PROFILE_TYPE,
  name: 'practice'
}, {
  id: SPECIALIST_PROFILE_TYPE,
  name: 'specialist'
}];
var PRACTICE_TABS = exports.PRACTICE_TABS = [{ id: null, name: 'None' }, { id: 'About Our Practice', name: 'About Our Practice' }, { id: 'Reviews', name: 'Reviews' }, { id: 'Recommendations', name: 'Recommendations' }];

var SPECIALIST_TABS = exports.SPECIALIST_TABS = [{ id: null, name: 'None' }, { id: 'Reviews', name: 'Reviews' }, { id: 'Recommendations', name: 'Recommendations' }];

var WF_LIST_LAYOUTS = exports.WF_LIST_LAYOUTS = [{ id: 'WF_LIST_A', name: 'List Layout A', width: '500px' }, { id: 'WF_LIST_B', name: 'List Layout B', width: '500px' }];

var WF_MICRO_STAR_LAYOUTS = exports.WF_MICRO_STAR_LAYOUTS = [{ id: 'WF_MICRO_STAR_A', name: 'Micro Star Layout A', width: '230px' }, { id: 'WF_MICRO_STAR_B', name: 'Micro Star Layout B', width: '230px' }, { id: 'WF_MICRO_STAR_C', name: 'Micro Star Layout C', width: '230px' }, { id: 'WF_MICRO_STAR_D', name: 'Micro Star Layout D', width: '230px' }, { id: 'WF_MICRO_STAR_E', name: 'Micro Star Layout E', width: '470px' }, { id: 'WF_MICRO_STAR_F', name: 'Micro Star Layout F', width: '340px' }, { id: 'WF_MICRO_STAR_G', name: 'Micro Star Layout G', width: '340px' }, { id: 'WF_MICRO_STAR_H', name: 'Micro Star Layout H', width: '280px' }, { id: 'WF_MICRO_STAR_I', name: 'Micro Star Layout I', width: '100px' }];

var WF_CAROUSEL_LAYOUTS = exports.WF_CAROUSEL_LAYOUTS = [{ id: 'WF_CAROUSEL_A', name: 'Carousel Layout A', width: '1110px' }];

var WF_GRID_LAYOUTS = exports.WF_GRID_LAYOUTS = [{ id: 'WF_GRID_A', name: 'Grid Layout A', width: '820px' }, { id: 'WF_GRID_B', name: 'Grid Layout B', width: '550px' }];

var WF_HORIZONTAL_LAYOUTS = exports.WF_HORIZONTAL_LAYOUTS = [{ id: 'WF_HORIZONTAL_XL', name: 'Horizontal Layout XL', width: '1090px' }, { id: 'WF_HORIZONTAL_L', name: 'Horizontal Layout L', width: '980px' }, { id: 'WF_HORIZONTAL_M', name: 'Horizontal Layout M', width: '850px' }, { id: 'WF_HORIZONTAL_S', name: 'Horizontal Layout S', width: '590px' }, { id: 'WF_HORIZONTAL_XS', name: 'Horizontal Layout XS', width: '345px' }, { id: 'WF_HORIZONTAL_A', name: 'Horizontal Layout A', width: '180px' }];

var WF_PEER_RECOMMENDATION_LAYOUTS = exports.WF_PEER_RECOMMENDATION_LAYOUTS = [{ id: 'WF_PEER_RECOMMENDATION_A', name: 'Peer Recommendation Layout A', width: '1090px' }];

var WF_GROUP_REVIEWS_LAYOUTS = exports.WF_GROUP_REVIEWS_LAYOUTS = [{ id: 'WF_GROUP_REVIEWS_A', name: 'Group Reviews Layout A', width: '1090px' }];

var WF_PEER_RECOMMENDATION_TABS_FOR_DROPDOWN = exports.WF_PEER_RECOMMENDATION_TABS_FOR_DROPDOWN = [{ id: "WF_PEER_RECOMMENDATION_PRACTICE_REVIEWS_TAB", name: 'About Practice Tab', idx: 0 }, { id: "WF_PEER_RECOMMENDATION_DOCTORS_REVIEWS_TAB", name: 'Reviews', idx: 1 }, { id: "WF_PEER_RECOMMENDATION_DOCTORS_RECOMMENDATIONS_TAB", name: 'Recommendations', idx: 2 }];

var queryStringFromObject = exports.queryStringFromObject = function queryStringFromObject(obj) {
  var string = '?';
  (0, _keys2.default)(obj).map(function (item) {
    string += item + '=' + ((0, _typeof3.default)(obj[item]) === 'object' ? encodeURIComponent((0, _stringify2.default)(obj[item])) : encodeURIComponent(obj[item])) + '&';
  });
  return string.substring(0, string.length - 1);
};